<template>
  <main class="card-detail">
    <van-cell-group>
      <van-cell
        :value="hospital"
        title="医院" />
      <van-cell
        :value="relation"
        title="关系" />
      <van-cell
        :value="medicalCardId"
        title="就诊卡号" />
      <van-cell
        :value="name"
        title="申请人姓名" />
      <van-cell
        :value="idCardCode"
        title="二代身份证" />
      <van-cell
        :value="phone"
        title="手机号" />
    </van-cell-group>
    <div class="p-3">
      <van-row class="pb-2">
        <van-col span="24">
          <van-button
            type="primary"
            size="large"
            @click="handleOnSubmit">解绑就诊卡</van-button>
        </van-col>
      </van-row>
    </div>
  </main>
</template>

<script>
import currentCardService from '@/libs/currentCard';
export default {
  name: 'CardDetail',
  data() {
    return {
      name: '',
      idCardCode: '',
      phone: '',
      medicalCardId: '',
      relation: '',
      hospital: '',
    };
  },
  activated() {
    this.handleLoad();
  },
  methods: {
    async handleLoad() {
      const accessToken = localStorage.getItem('accessToken');
      const { hospitalId } = this.$route.query;
      const { id } = this.$route.params;
      let params = {
        access_token: accessToken,
        hospital_id: hospitalId,
      };
      let headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const cardList = await currentCardService.listCards(params, headers);
      const data = cardList.filter((value) => {
        const result = value.medical_card_id === id;
        return result;
      });
      this.name = data[0].name;
      this.idCardCode = data[0].id_card_code;
      this.phone = data[0].phone;
      this.medicalCardId = data[0].medical_card_id;
      this.relation = data[0].relation;
      this.hospital = data[0].hospital_flag;
    },
    async handleOnSubmit() {
      const { hospitalId } = this.$route.query;
      const accessToken = localStorage.getItem('accessToken');
      await this.$http.post(
        '/patient-api/webapi/user/unbind-medical-card',
        {
          medical_card_id: this.medicalCardId,
          hospital_id: hospitalId,
        },
        {
          Authorization: `Bearer ${accessToken}`,
        },
      );
      this.$toast.success('解绑成功');
      this.$router.replace({ name: 'card' });
    },
  },
};
</script>

<style scoped>
.card-detail >>> .van-cell__title {
  max-width: 6rem;
}
</style>
